/**
 * Camp Essentials > Recipes — mockup-aligned shell and routes.
 */
import React, { useState, useEffect } from 'react';
import { useNavigate, Routes, Route } from 'react-router-dom';
import { FaUtensils, FaChevronLeft, FaPlus } from 'react-icons/fa';
import { GiCookingPot } from 'react-icons/gi';
import { CommunityRecipesHome } from './CommunityRecipesHome';
import { CommunityRecipeCreate } from './CommunityRecipeCreate';
import { CommunityRecipeDetail } from './CommunityRecipeDetail';
import { CommunityRecipeFavorites } from './CommunityRecipeFavorites';
import { HelpMeCook } from './HelpMeCook';
import { HelpMeCookModal } from './HelpMeCookModal';
import { SubmitRecipeModal } from './SubmitRecipeModal';
import { YButton } from '../../../ui/YButton';
import { communityRecipesService } from '../services/communityRecipesService';
import './camp-essentials-shell.css';
import './camp-essentials-gear.css';
import './camp-recipes-shell.css';

function CampRecipesHomePage() {
  const navigate = useNavigate();
  const [totalCommunity, setTotalCommunity] = useState(0);
  const [helpOpen, setHelpOpen] = useState(false);
  const [submitOpen, setSubmitOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;
    communityRecipesService
      .feed({ limit: 1, offset: 0 })
      .then((data) => {
        if (!cancelled) {
          setTotalCommunity(typeof data.total_community === 'number' ? data.total_community : 0);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="camp-essentials-shell camp-recipes-page" data-testid="camp-recipes-page">
      <svg className="camp-essentials-shell__bg-grid" aria-hidden="true">
        <defs>
          <pattern
            id="camp-recipes-shell-grid"
            width="40"
            height="40"
            patternUnits="userSpaceOnUse"
          >
            <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="1" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#camp-recipes-shell-grid)" />
      </svg>

      <div className="camp-essentials-shell__inner camp-recipes-page__inner">
        <button
          type="button"
          className="camp-essentials-gear__back"
          onClick={() => navigate('/camp-essentials')}
        >
          <FaChevronLeft size={12} aria-hidden="true" />
          Camp Essentials
        </button>

        <header className="camp-recipes-page__header">
          <div className="camp-recipes-page__header-row">
            <div className="camp-essentials-shell__header-main">
              <div className="camp-essentials-shell__header-icon" aria-hidden="true">
                <FaUtensils size={18} />
              </div>
              <div>
                <h1 className="camp-essentials-shell__title" data-testid="page-hero">
                  Wild Game Recipes
                </h1>
                <p className="camp-essentials-shell__subtitle">
                  {totalCommunity > 0
                    ? `${totalCommunity} recipe${totalCommunity === 1 ? '' : 's'} from the community`
                    : 'Community & curated camp dishes'}
                </p>
              </div>
            </div>
            <div className="camp-recipes-page__header-actions">
              <YButton
                type="button"
                className="camp-recipes-page__help-btn"
                onClick={() => setHelpOpen(true)}
              >
                <GiCookingPot aria-hidden="true" />
                Help me cook
              </YButton>
              <YButton type="button" onClick={() => setSubmitOpen(true)}>
                <FaPlus aria-hidden="true" />
                Submit recipe
              </YButton>
            </div>
          </div>
        </header>

        <CommunityRecipesHome />
      </div>

      <HelpMeCookModal show={helpOpen} onHide={() => setHelpOpen(false)} />
      <SubmitRecipeModal show={submitOpen} onHide={() => setSubmitOpen(false)} />
    </div>
  );
}

export function CampRecipesPage() {
  return (
    <Routes>
      <Route path="new" element={<CommunityRecipeCreate />} />
      <Route path="favorites" element={<CommunityRecipeFavorites />} />
      <Route path="help" element={<HelpMeCook />} />
      <Route path=":id/edit" element={<CommunityRecipeCreate />} />
      <Route path=":id" element={<CommunityRecipeDetail />} />
      <Route path="*" element={<CampRecipesHomePage />} />
    </Routes>
  );
}
